import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  pinInputField: {
    "& .MuiInputBase-formControl input": {
      padding: "0px",
      margin: "0px 2px",
      textAlign: "center",
      border: "1px solid rgb(224, 224, 224)",
      background: "rgb(255, 255, 255)",
      width: "64px",
      height: "65px",
      borderRadius: "8px",
      fontSize: "24px",
    },

    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "1px solid #E0E0E0",
      },
      "&:hover fieldset": {
        border: "1px solid #575757",
      },
      "&.Mui-focused fieldset": {
        border: "1px solid #575757",
      },
      "&.Mui-disabled fieldset": {
        border: "1px solid #E0E0E0",
      },
    },
  },
}));

export default useStyles;
